import _ from 'lodash';

export const CALENDAR_TYPES = {
  ACADEMIC_PLANNER: 'AcademicPlanner',
  SESSIONS: 'Sessions',
};

export const CALENDAR_TYPES_DEFAULT = CALENDAR_TYPES.ACADEMIC_PLANNER;

export const RESOURCE_TYPES = {
  FACULTY: 'faculty',
  FACILITY: 'facility',
};
export const RESOURCE_TYPES_DEFAULT = RESOURCE_TYPES.FACULTY;
export const RESOURCE_TYPES_OPTIONS = [
  {
    label: 'Faculty',
    value: RESOURCE_TYPES.FACULTY,
  },
  {
    label: 'Facility',
    value: RESOURCE_TYPES.FACILITY,
  },
];
export const EVENT_TYPES = {
  REFERENCE: 'reference',
  SESSION: 'session',
  ALL: 'all',
  EXAM: 'exam',
};
export const EVENT_TYPES_DEFAULT = EVENT_TYPES.ALL;

export const EVENT_TYPE_OPTIONS = [
  {
    label: 'References',
    value: EVENT_TYPES.REFERENCE,
  },

  {
    label: 'Sessions',
    value: EVENT_TYPES.SESSION,
  },
  {
    label: 'All',
    value: EVENT_TYPES.ALL,
  },
  {
    label: 'Exam',
    value: EVENT_TYPES.EXAM,
  },
];

export const RECURRENT_DAYS = [
  {
    value: 'Sunday',
    label: 'SUN',
  },
  {
    value: 'Monday',
    label: 'MON',
  },
  {
    value: 'Tuesday',
    label: 'TUE',
  },
  {
    value: 'Wednusday',
    label: 'WED',
  },
  {
    value: 'Thursday',
    label: 'THU',
  },
  {
    value: 'Friday',
    label: 'FRI',
  },
  {
    value: 'Saturday',
    label: 'SAT',
  },
];

export const SUBJECT_UNASSIGNED = 'Unassigned';

export const getResources = function (
  resourceType = RESOURCE_TYPES_DEFAULT,
  { faculties, facilities }
) {
  let resources = [];
  let resourceColumns = [];
  if (resourceType === RESOURCE_TYPES.FACULTY) {
    // ?.map(f => ({ ...f, id: f.facultyId }));
    resources = faculties;
    resourceColumns = [{ field: 'facultyName', headerContent: 'Faculty' }];
  } else if (resourceType === RESOURCE_TYPES.FACILITY) {
    // ?.map(f => ({ ...f }));
    resources = facilities;
    resourceColumns = [
      { field: 'facilityName', headerContent: 'Facility' },
      { field: 'facilityCapacity', headerContent: 'Capacity' },
      { field: 'facilityType', headerContent: 'Type' },
    ];
  }
  return { resources, resourceColumns };
};

const eventsResourceMapping = function (
  eventType,
  events = [],
  resourceType = RESOURCE_TYPES_DEFAULT
) {
  // based on resourceType change resourceId
  switch (eventType) {
    case EVENT_TYPES.REFERENCE:
      return resourceType === RESOURCE_TYPES.FACULTY
        ? events.map((e) => ({
            ...e,
            resourceIds: _.reject(
              [e.faculty1Id, e.faculty2Id, e.faculty3Id],
              _.isEmpty
            ),
          }))
        : events;

    case EVENT_TYPES.SESSION:
      return events.map((e) => ({
        ...e,
        resourceId:
          resourceType === RESOURCE_TYPES.FACULTY
            ? e?.FacultyBooking?.contactId
            : e?.FacilityBooking?.facilityId,
      }));
    case EVENT_TYPES.EXAM:
      return events.map((e) => ({
        ...e,
        resourceId:
          resourceType === RESOURCE_TYPES.FACULTY
            ? e?.FacultyBooking?.contactId
            : e?.FacilityBooking?.facilityId,
      }));
    default:
      return events;
  }
};

export const filterEvents = function ({
  eventType = EVENT_TYPES_DEFAULT,
  resourceType = RESOURCE_TYPES_DEFAULT,
  referenceActivities = [],
  sessions = [],
  selectedSubjects = [],
  isUnassigned = true,
}) {
  if (!selectedSubjects.length) {
    return [];
  }

  let events = [];

  // add references to events
  if (eventType === EVENT_TYPES.REFERENCE || eventType === EVENT_TYPES.ALL) {
    events = [
      ...events,
      ...eventsResourceMapping(
        EVENT_TYPES.REFERENCE,
        referenceActivities,
        resourceType
      ),
    ];
  }

  //add sessions to events
  if (eventType === EVENT_TYPES.SESSION || eventType === EVENT_TYPES.ALL) {
    events = [
      ...events,
      ...eventsResourceMapping(EVENT_TYPES.SESSION, sessions, resourceType),
    ];
  }
  //add sessions to events
  if (eventType === EVENT_TYPES.EXAM || eventType === EVENT_TYPES.ALL) {
    events = [
      ...events,
      ...eventsResourceMapping(EVENT_TYPES.EXAM, sessions, resourceType),
    ];
  }
  // filter events by subjects
  const isUnassignedSelected = selectedSubjects.includes(SUBJECT_UNASSIGNED);
  console.log('selectedSubjects: ', selectedSubjects);
  // events = _.intersectionWith(events, selectedSubjects, (event, sub) => {
  //     const courseOfferingId = event?.SubjectPlanner?.courseOfferingId;
  //     const subjectId = event?.subjectId;
  //     // if unassigned
  //     if (isUnassignedSelected && !courseOfferingId && !subjectId) {
  //         return true
  //     }
  //     return (courseOfferingId === sub || subjectId === sub)
  // })
  events = events.filter((e) => {
    // if unassigned
    if (
      isUnassignedSelected &&
      !e?.SubjectPlanner?.courseOfferingId &&
      !e?.subjectId
    ) {
      return true;
    }

    return (
      _.intersection(selectedSubjects, [
        e?.subjectId,
        e?.SubjectPlanner?.courseOfferingId,
      ]).length > 0
    );
  });

  // event map and add resourceId by resourceType
  return events;
};

export const parseCourseVersionForTree = function (data) {
  return {
    id: '0',
    name: 'Select All',
    children: _.map(data, (course) => {
      return {
        ...course,
        name: course.courseName,
        children: _.map(course.courseOffering || [], (section) => ({
          ...section,
          name: section.courseSectionId,
        })),
      };
    }),
  };
};
